var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-text-small footer"},[_c('TermsOfServices'),_c('span',{staticClass:"mx-6"},[_vm._v("|")]),_c('a',{staticClass:"SupportWidget"},[_vm._v(_vm._s(_vm.$t('shared.support')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }